module.exports = __webpack_public_path__ + "static/media/loanx-nav-footer-Pattern.9d34484c.svg";